import { useContext, useMemo } from 'react';
import AppConfigurationContext from '../../contexts/application/AppConfigurationContext';
import TextResourceService, { ITextResourceService } from '../../data/textresource-service/TextResourceService';
import { IAppConfiguration } from '../../models';

/**
 *
 * This hook gets an instance of the TextResourceService class
 * to be used in a Component.
 *
 * @returns an ITextResourceService interface implemented by
 * an instance of the TextResourceService class.
 */
export function useTextResourceService(appConfig?: IAppConfiguration): ITextResourceService {
  const contextConfig = useContext(AppConfigurationContext)!;

  const finalAppConfig = appConfig ?? contextConfig;

  const service = useMemo(() => new TextResourceService(finalAppConfig), [finalAppConfig]);

  return service;
}
